// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 2%;
}
.login img {
  width: 20%;
}
.login h1 {
  text-transform: uppercase;
  font-size: 2.5rem;
  color: #4d4d4d;
  text-align: center;
}
.login form {
  margin: 0 auto;
}
.login form input, .login form button {
  border: 0;
  outline: 0;
  font-size: 1.2rem;
  border-radius: 320px;
  padding: 16px;
  background-color: #ebecf0;
  text-shadow: 1px 1px 0 #fff;
}
.login form input {
  margin-right: 8px;
  box-shadow: inset 2px 2px 5px, #babecc, inset -5px -5px 10px #fff;
  width: 100%;
  box-sizing: border-box;
  transition: all 0.2s ease-in-out;
  appearance: none;
  -webkit-appearance: none;
  margin-bottom: 5%;
}
.login form input:focus {
  box-shadow: inset 1px 1px 2px #babecc, inset -1px -1px 2px #fff;
}
.login form input[type=submit] {
  font-weight: bold;
  box-shadow: -5px -5px 8px #fff, 5px 5px 8px #babecc;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  font-weight: 600;
  margin: 5% auto;
  width: 100%;
  display: block;
}
.login form input[type=submit]:hover {
  box-shadow: -2px -2px 5px #fff, 2px 2px 5px #babecc;
}
.login form input[type=submit]:active {
  box-shadow: inset 1px 1px 2px #babecc, inset -1px -1px 2px #fff;
}
.login .pass {
  border: none;
  background: #fff;
  cursor: pointer;
}
.login .pass:hover {
  color: #BF1a1a;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/login/login.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AACJ;AAAI;EACI,UAAA;AAER;AAAI;EACI,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAER;AAAI;EACI,cAAA;AAER;AADQ;EACI,SAAA;EACA,UAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;EACA,2BAAA;AAGZ;AADQ;EACI,iBAAA;EACA,iEAAA;EACA,WAAA;EACA,sBAAA;EACA,gCAAA;EACA,gBAAA;EACA,wBAAA;EACA,iBAAA;AAGZ;AAFY;EACI,+DAAA;AAIhB;AAAQ;EACI,iBAAA;EACA,mDAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;AAEZ;AADY;EACI,mDAAA;AAGhB;AADY;EACI,+DAAA;AAGhB;AACI;EACI,YAAA;EACA,gBAAA;EACA,eAAA;AACR;AAAQ;EACI,cAAA;AAEZ","sourcesContent":[".login{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding-top: 2%;\n    img{\n        width: 20%;\n    }\n    h1{\n        text-transform: uppercase;\n        font-size: 2.5rem;\n        color: #4d4d4d;\n        text-align: center;\n    }\n    form{\n        margin: 0 auto;\n        input, button{\n            border: 0;\n            outline: 0;\n            font-size: 1.2rem;\n            border-radius: 320px;\n            padding: 16px;\n            background-color: #ebecf0;\n            text-shadow: 1px 1px 0 #fff;\n        }\n        input{\n            margin-right: 8px;\n            box-shadow: inset 2px 2px 5px, #babecc, inset -5px -5px 10px #fff;\n            width: 100%;\n            box-sizing: border-box;\n            transition: all 0.2s ease-in-out;\n            appearance: none;\n            -webkit-appearance: none;\n            margin-bottom: 5%;\n            &:focus{\n                box-shadow: inset 1px 1px 2px #babecc, inset -1px -1px 2px #fff;\n\n            }\n        }\n        input[type=submit] {\n            font-weight: bold;\n            box-shadow: -5px -5px 8px #fff, 5px 5px 8px #babecc;\n            transition: all 0.2s ease-in-out;\n            cursor: pointer;\n            font-weight: 600;\n            margin: 5% auto;\n            width: 100%;\n            display: block;\n            &:hover{\n                box-shadow: -2px -2px 5px #fff, 2px 2px 5px #babecc;\n            }\n            &:active{\n                box-shadow: inset 1px 1px 2px #babecc, inset -1px -1px 2px #fff;\n            }\n        }\n    }\n    .pass{\n        border: none;\n        background: #fff;\n        cursor: pointer;\n        &:hover{\n            color: #BF1a1a;\n        }\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
